import type AppModuleStore from './schema/AppModuleStore';
import type AsyncStatus from 'mini-common-schema/lib/schema/AsyncStatus';
import { type Banner } from './schema/Banner';
import { createStore } from 'satcheljs';

const store = createStore<AppModuleStore>('miniAppModule', {
    module: null,
    shownBanner: 'None',
    offlineSyncStatus: 0,
    fontScale: 1,
})();

export const getStore = () => store;
